import { cn } from '@/shared/utils/cn';
import React from 'react';
import { ListHeader } from '../molecules/ListHeader';
import { ListSeparator } from '../molecules/ListSeparator';

export interface ListFiltersItem {
  id: string;
  label: string;
}

export interface ListFiltersProps {
  title?: string;
  items: ListFiltersItem[];
  selectedItemId?: string;
  onItemClick?: (itemId: string) => void;
  className?: string;
}

export const ListFilters: React.FC<ListFiltersProps> = ({
  title = 'Filtrar Por',
  items,
  selectedItemId,
  onItemClick,
  className,
}) => {
  return (
    <div
      className={cn(
        'ui-rounded-surface-card ui-border ui-border-default ui-bg-fill ui-p-8 ui-shadow-03',
        'ui-flex ui-min-w-[208px] ui-flex-col ui-gap-8',
        className,
      )}
    >
      {/* Title */}
      <div className="ui-text-body-sm-regular ui-font-body-sm-bold ui-text-primary">{title}</div>

      <ListSeparator />

      {/* Filter Items */}
      <div className="ui-flex ui-flex-col ui-gap-8">
        {items.map((item) => {
          const isSelected = selectedItemId === item.id;
          return (
            <div
              key={item.id}
              onClick={() => onItemClick?.(item.id)}
              className={cn(
                'ui-cursor-pointer ui-rounded-control-sm ui-px-8 ui-py-6 ui-text-body-sm-regular ui-font-body-sm-medium ui-transition-all',
                {
                  // Selected: azul oscuro
                  'ui-bg-fill-brand ui-text-on-color': isSelected,
                  // Default text
                  'ui-text-primary': !isSelected,
                  // Hover: gris claro (solo cuando no está seleccionado)
                  'hover:ui-bg-fill-hover': !isSelected,
                },
              )}
            >
              {item.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};
